export default "__VITE_ASSET__BqtzUgzK__"